class HeaderCartDropdown extends CartItems {
  constructor() {
    super();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-offcanvas-nav',
        section: 'header-cart-dropdown',
        selector: '[data-cart-content]'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('header-cart-dropdown', HeaderCartDropdown);
